import React, { useMemo } from 'react'
import { getFeatureConfig, type FeatureConfig } from '../config/features'

/**
 * Hook to access feature configuration
 */
export function useFeatures(): FeatureConfig {
  return useMemo(() => getFeatureConfig(), [])
}

/**
 * Hook to check if a specific feature is enabled
 */
export function useFeature(feature: keyof FeatureConfig): boolean {
  const config = useFeatures()
  return config[feature]
}

/**
 * Component wrapper for conditional feature rendering
 */
export function FeatureGuard({ 
  feature, 
  children, 
  fallback = null 
}: { 
  feature: keyof FeatureConfig
  children: React.ReactNode
  fallback?: React.ReactNode
}) {
  const isEnabled = useFeature(feature)
  return isEnabled ? React.createElement(React.Fragment, {}, children) : React.createElement(React.Fragment, {}, fallback)
}

export default useFeatures
